export default __webpack_public_path__ + "static/media/maintenance.cd77823a.svg";